(() => {
  const st = (window.__cartOpenCtl = window.__cartOpenCtl || {
    allow: false,        // السماح بالفتح (يدوي فقط)
    lastManualTs: 0
  });

  const now = () => Date.now();

  // ✅ اعتبري الضغط اليدوي فقط على أيقونة الكارت
  const MANUAL_TRIGGERS = ".wt-cart__trigger, #cart-icon-bubble, .header__icon--cart";

  document.addEventListener("click", (e) => {
    const t = e.target;
    if (!t || !t.closest) return;

    if (t.closest(MANUAL_TRIGGERS)) {
      st.allow = true;
      st.lastManualTs = now();
    }
  }, true);

  // ===== Close helpers =====
  function closeThemeDrawer() {
    const cd = document.querySelector("cart-drawer");
    if (!cd) return;

    cd.removeAttribute("open");
    const drawer = cd.querySelector(".wt-cart__drawer");
    if (drawer) drawer.classList.remove("wt-cart__drawer--open");

    document.body.classList.remove("page-overlay-cart-on");
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  }

  function closeAvadaDrawer() {
    const aov =
      document.getElementById("aov-cart-drawer") ||
      document.querySelector(".aov-cart-drawer");

    if (!aov) return;

    const closeBtn =
      aov.querySelector('[aria-label*="close" i]') ||
      aov.querySelector(".aov-cart-drawer__close, .close, .close-btn, button.close");

    if (closeBtn) closeBtn.click();

    // fallback: اخفيه لو مفيش زرار close واضح
    aov.classList.remove("open", "active", "is-open", "shown", "visible");
    aov.setAttribute("aria-hidden", "true");

    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  }

  function isThemeOpen() {
    return !!(
      document.querySelector("cart-drawer[open]") ||
      document.querySelector("cart-drawer .wt-cart__drawer.wt-cart__drawer--open")
    );
  }

  function isAovOpen() {
    const aov =
      document.getElementById("aov-cart-drawer") ||
      document.querySelector(".aov-cart-drawer");
    if (!aov) return false;

    const r = aov.getBoundingClientRect();
    const cs = window.getComputedStyle(aov);
    return r.width > 10 && r.height > 10 && cs.display !== "none" && cs.visibility !== "hidden";
  }

  // ✅ لو اتفتح من غير إذن (st.allow = false) اقفليه فورًا
  function enforce() {
    if (isThemeOpen() && !st.allow) closeThemeDrawer();
    if (isAovOpen() && !st.allow) closeAvadaDrawer();

    // لو مفيش Drawer مفتوح، رجّعي allow = false بعد ثانيتين من آخر ضغط يدوي
    if (!isThemeOpen() && !isAovOpen() && st.allow && (now() - st.lastManualTs > 2000)) {
      st.allow = false;
    }
  }

  // ✅ امنعي الفتح من جوه الثيم لو مش يدوي
  async function patchCartDrawer() {
    try { await customElements.whenDefined("cart-drawer"); } catch (e) {}
    const El = customElements.get("cart-drawer");
    if (!El || El.prototype.__openCtlPatched) return;

    const orig = El.prototype.toggleDrawerClasses;
    if (typeof orig === "function") {
      El.prototype.toggleDrawerClasses = function () {
        const opening = !this.hasAttribute("open");
        if (opening && !st.allow) return; // ممنوع فتح تلقائي
        const res = orig.apply(this, arguments);
        // لو اتقفل يدويًا رجّعي allow=false
        if (!this.hasAttribute("open")) st.allow = false;
        return res;
      };
    }

    El.prototype.__openCtlPatched = true;
  }

  patchCartDrawer();

  const mo = new MutationObserver(enforce);
  mo.observe(document.documentElement, { subtree: true, childList: true, attributes: true });

  setInterval(enforce, 150);
  window.addEventListener("load", () => { setTimeout(enforce, 0); setTimeout(enforce, 500); });
})();
